import useFetch from '~/composables/api/useFetch';
import { BagService } from '../services/Bag.service';

export const useBag = () => {
  const service = new BagService();
  return useFetch(service.fetch.bind(service));
};
